import { TaskPlannerSchemaTypes } from "@bfc-software/api-schemas";
import { getEnv } from "@bfc-software/bfc-web-ui/environment";
import {
  aaaTokenOrToken,
  useAuthenticatedApi,
  useAuthenticatedFetchClient,
} from "@bfc-software/bfc-web-ui/lib/authenticated-api";

type Paths = TaskPlannerSchemaTypes.paths;

const spec = () => ({
  baseUrl: `${getEnv().tpsServiceBase}/taskPlanner/v1`,
  select: aaaTokenOrToken,
});

export const useTaskPlannerApi = () => useAuthenticatedApi<Paths>(spec());

/** Stable client for imperative use (callbacks, queryFn). Rebuilt only when the token changes. */
export const useTaskPlannerFetchClient = () =>
  useAuthenticatedFetchClient<Paths>(spec());

export type TaskPlannerFetchClient = ReturnType<
  typeof useTaskPlannerFetchClient
>;
